import React from 'react';
import { Link } from 'react-router-dom';
import WordmarkLogo from './WordmarkLogo';

export default function SiteFooter() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <WordmarkLogo size={22} />
            <p className="footer-brand-desc">
              AI built for Africa, by Africa. Healthcare, agriculture, finance, safety — the intelligence behind the continent's hardest problems.
            </p>
          </div>
          <div>
            <div className="footer-col-title">Platform</div>
            <div className="footer-links">
              <a href="/#platform">Our AI</a>
              <Link to="/developers">Developers</Link>
              <Link to="/chat">Chat</Link>
              <a href="/#platform">Voice</a>
              <a href="/#platform">Vision</a>
            </div>
          </div>
          <div>
            <div className="footer-col-title">Solutions</div>
            <div className="footer-links">
              <Link to="/solutions/safety">Safety & Security</Link>
              <Link to="/solutions/fintech">Finance & Inclusion</Link>
              <Link to="/solutions/energy">Energy & Grid</Link>
              <Link to="/solutions/agriculture">Agriculture</Link>
              <Link to="/solutions/health">Health</Link>
            </div>
          </div>
          <div>
            <div className="footer-col-title">Developers</div>
            <div className="footer-links">
              <Link to="/docs">Docs</Link>
              <Link to="/docs">SDKs</Link>
              <Link to="/docs">Cookbook</Link>
              <Link to="/docs">Changelog</Link>
              <Link to="/docs">Status</Link>
            </div>
          </div>
          <div>
            <div className="footer-col-title">Company</div>
            <div className="footer-links">
              <Link to="/whitepaper">Whitepaper</Link>
              <a href="/#about">About</a>
              <a href="mailto:hello@cybernate.ai">Contact</a>
              <Link to="/legal">Privacy</Link>
              <Link to="/terms">Terms</Link>
            </div>
          </div>
        </div>
        <div className="footer-base">
          <span>© 2026 CYBERNATE LABS · LAGOS / NAIROBI</span>
          <span>
            <span className="status-dot" style={{ marginRight: 6, verticalAlign: 'middle' }} />
            ALL SYSTEMS NORMAL
          </span>
        </div>
      </div>
    </footer>
  );
}
